module.exports = require("./scripts/index.js");


//////////////////
// WEBPACK FOOTER
// ./src/widget-hdfc-portal-compare-overlay/model.xml
// module id = 0
// module chunks = 46